import { render, staticRenderFns } from "./ServiceIntegrations.vue?vue&type=template&id=2ea7c97d&"
import script from "./ServiceIntegrations.vue?vue&type=script&lang=js&"
export * from "./ServiceIntegrations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports